/** localStorage wrapper that never throws (private mode, blocked storage, SSR/tests). */
const PREFIX = 'campus-life:';

function backend(): Storage | null {
  try {
    return typeof localStorage !== 'undefined' ? localStorage : null;
  } catch {
    return null;
  }
}

export const storage = {
  get(key: string): string | null {
    try {
      return backend()?.getItem(PREFIX + key) ?? null;
    } catch {
      return null;
    }
  },
  set(key: string, value: string): void {
    try {
      backend()?.setItem(PREFIX + key, value);
    } catch {
      /* storage full or unavailable: progress just isn't persisted */
    }
  },
  remove(key: string): void {
    try {
      backend()?.removeItem(PREFIX + key);
    } catch {
      /* ignore */
    }
  },
  getJSON<T>(key: string): T | null {
    const raw = this.get(key);
    if (!raw) return null;
    try {
      return JSON.parse(raw) as T;
    } catch {
      return null;
    }
  },
  setJSON(key: string, value: unknown): void {
    this.set(key, JSON.stringify(value));
  },
};
